<template>
  <v-app
    ><v-navigation-drawer app floating permanent :mini-variant="$vuetify.breakpoint.mdAndDown">
      <SideBar></SideBar>
    </v-navigation-drawer>

    <v-system-bar dark height="48px" class="pa-0" app>
      <NavBar />
    </v-system-bar>

    <v-main class="pa-0"
      ><v-container fluid >
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import SideBar from "@/components/SideBar.vue";
export default {
  components: {
    NavBar,
    SideBar,
  },
};
</script>
